import React from 'react';
import { Route } from 'react-router-dom';

const isConditionalRoute = (routes, key) => {
  const conditionalRouteRegex = /(:(?<param>.*?)\((?<options>.*?)\))/g;
  const { param, options: rawOptions } = { ...conditionalRouteRegex.exec(key)?.groups };

  if (param && rawOptions && typeof routes[key] === 'object') {
    const options = rawOptions.split('|');

    // Check if route
    //  - has an object matching the shape { [param]: { [options[0]]: null, [options[1]]: null, etc... } }
    //  - has all options referenced by param
    const variableExists = routes[key]?.[param] !== undefined && typeof routes[key]?.[param] === 'object';
    const hasAllOptions = options.every(
      (option) => routes[key]?.[param]?.[option] && typeof routes[key]?.[param]?.[option] === 'function',
    );

    return variableExists && hasAllOptions;
  }
  return false;
};

const parseConditionalRoute = (routes, key) => {
  const conditionalRouteRegex = /(:(?<param>.*?)\((?<options>.*?)\))/g;
  const { param } = { ...conditionalRouteRegex.exec(key)?.groups };

  const { [param]: components, ...rest } = routes[key];

  return (
    <Route
      key={key}
      path={key.length > 0 ? key : null}
      render={(props) => {
        const {
          match: {
            params: { [param]: paramValue },
          },
        } = props;
        const Component = components[paramValue];
        return <Component {...props} />;
      }}
      {...rest}
    />
  );
};

export default (routeObject) =>
  Object.keys(routeObject).map((key) => {
    if (isConditionalRoute(routeObject, key)) {
      return parseConditionalRoute(routeObject, key);
    }

    return (
      <Route
        key={key}
        path={key.length > 0 ? key : null}
        {...(typeof routeObject[key] === 'object' ? { ...routeObject[key] } : { component: routeObject[key] })}
      />
    );
  });
